import photo1 from "../../../assets/images/appImages/member-1.png";
import photo2 from "../../../assets/images/appImages/member-2.png";
import photo3 from "../../../assets/images/appImages/member-3.png";
import photo4 from "../../../assets/images/appImages/member-3.png";

export const TeamData = [
  {
    id: 1,
    photo: photo1,
    name: "Seydou Ly",
    role: "Fondateur et directeur général",
  },
  {
    id: 2,
    photo: photo2,
    name: "Boushra Ly",
    role: "Assistante",
  },
  {
    id: 3,
    photo: photo3,
    name: "Rachid",
    role: "Responsable des services de livraison",
  },
  {
    id: 4,
    photo: photo4,
    name: "Salma",
    role: "Vendeuse",
  },

]
